// extracted by mini-css-extract-plugin
module.exports = {"cancleBtn":"style_cancleBtn__3fy8i","welcomeImageDiv":"style_welcomeImageDiv__ohC_8","welcomeImage":"style_welcomeImage__1earO"};